import { Navigate, Outlet, RouteObject } from "react-router";
import { WorkOrderIndexRoute } from "@/routes/processes/[processId]/htz/work-orders/_components/work-order-index-route";
import { WorkOrderRoute } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/work-order-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/data/data-route";
import { PositionsRoute } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/positions/positions-route";
import { LaboratoryRoute } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/laboratory/laboratory-route";
import { WorkOrdersPlanningRoute } from "@/routes/processes/[processId]/htz/work-orders/planning/work-orders-planning-route";
import { WorkOrderPlanningRoute } from "@/routes/processes/[processId]/htz/work-orders/planning/[workOrderId]/work-order-planning-route";
import { WorkOrdersExecutionRoute } from "@/routes/processes/[processId]/htz/work-orders/execution/work-orders-execution-route";
import { WorkOrderExecutionRoute } from "@/routes/processes/[processId]/htz/work-orders/execution/[workOrderId]/work-order-execution-route";
import { WorkOrdersCompletionRoute } from "@/routes/processes/[processId]/htz/work-orders/completion/work-orders-completion-route";
import { WorkOrderCompletionRoute } from "@/routes/processes/[processId]/htz/work-orders/completion/[workOrderId]/work-order-completion-route";

const workOrderChildren: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="data" replace />,
  },
  {
    path: "data",
    element: <DataRoute />,
  },
  {
    path: "positions",
    element: <PositionsRoute />,
  },
  {
    path: "laboratory",
    element: <LaboratoryRoute />,
  },
];

export const htzWorkOrdersRoutes: RouteObject[] = [
  {
    index: true,
    element: <WorkOrderIndexRoute />,
  },
  {
    path: "planning",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersPlanningRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderPlanningRoute />,
        children: workOrderChildren,
      },
    ],
  },
  {
    path: "execution",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersExecutionRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderExecutionRoute />,
        children: workOrderChildren,
      },
    ],
  },
  {
    path: "completion",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersCompletionRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderCompletionRoute />,
        children: workOrderChildren,
      },
    ],
  },
  {
    path: ":workOrderId",
    element: <WorkOrderRoute />,
  },
];
